import { combineReducers } from "redux";
import authReducers from '../authentication/reducers'
import dashboardReducers from '../dashboard/reducers'
import booksReducers from '../books/reducers';
import ordersReducers from '../orders/reducers';
import operatorsReducers from '../operators/reducers';
import discountsReducers from '../discounts/reducers';
import customersReducers from '../customers/reducers';
import eventsReducers from '../events/reducers';
import { reducer as formReducer } from 'redux-form';
import reportReducers from '../report/reducers';
import storeReducers from '../settings/reducers';

export const initialState = {};

export default combineReducers({
    ...authReducers,
    ...dashboardReducers,
    ...booksReducers,
    ...ordersReducers,
    ...operatorsReducers,
    ...discountsReducers,
    ...customersReducers,
    ...reportReducers,
    ...storeReducers,
    ...eventsReducers,
    form : formReducer
});